import { GetHoldingsResponse } from '../../proto/generated/trading-bridge';
import api from './axiosClient';

export const getHoldings = async (accountId: string | undefined) => {
  try {
    const response = await api.get('/orders/holdings', {
      params: {
        accountId: accountId,
      },
      headers: {
        'Accept': 'application/x-protobuf',
      },
      responseType: 'arraybuffer',
    });
    const responseData = GetHoldingsResponse.decode(new Uint8Array(response.data));
    return responseData.holdings; // Assuming the response contains a 'holdings' field
  } catch (error: any) {
    console.error('Error fetching holdings:', error);
    console.error('Error response:', error.response);
    throw error;
  }
};